import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/core/services/auth.service";
import { EventService } from "src/app/core/services/event.service";
import { Location } from "@angular/common";
import { of } from "rxjs";
import { EncryptionService } from "src/app/core/services/encryption.service";
import { ToastService } from "src/app/core/services/toast.service";

@Component({
  selector: "app-view-event",
  templateUrl: "./view-event.component.html",
  styleUrls: ["./view-event.component.css"],
})
export class ViewEventComponent implements OnInit {
  categoryId: any;
  eventList: any;
  totalEvents: any = 5;
  searchTerm: any;
  image: any;
  min: any;
  localMin: any;
  moreEvents = false;
  filteredData: any;
  categoryName: any;
  isLoading = true;
  showScrollButton = false;
  enc_eventData: any;
  showLockedPopup = false;
  lockedPopupIsHost = false;

  constructor(
    private router: Router,    private encryptionService: EncryptionService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private eventService: EventService,
    private location: Location,
    private toastService: ToastService) { }

  ngOnInit() {
    this.isLoading = true;
    window.addEventListener('scroll', this.onCategoryScroll.bind(this));
    this.min = 0;
    this.image = "/assets/images/picaggoLogin.png";

    this.getEventsList();
    // this.eventService.retrievePassedEvent().subscribe((data) => {
    //   if(!data.events)
    //   {
    //     // // // console.log({data});
    //     //const cat_data = data.filter(categoryId => categoryId > 5);
    //     if (data.length > 0) {
    //       this.isLoading = false;
    //       this.eventList = data[0];
    //       this.eventName = data[1].category_name;
    //      // const randomIndex = Math.floor(Math.random() * data[0].length);
    //    //   // // // console.log({randomIndex});

    //      // this.image = this.eventList[randomIndex].imageUrl != null ? this.eventList[randomIndex].imageUrl : "";
    //     } else {
    //       this.router.navigateByUrl("/home");
    //     }
    //   }

    // });
    // // this.eventService.retrievePassedEvent().subscribe((data) => {
    // //   if (data.events) {
    // //     this.isLoading = false;
    // //     this.eventList = data.events;
    // //     this.eventName = data.name;
    // //     const randomIndex = Math.floor(Math.random() * this.eventList.length);
    // //     this.image = this.eventList[randomIndex].imageUrl;
    // //   } else {
    // //     this.router.navigateByUrl("/home");
    // //   }
    // // });
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onCategoryScroll.bind(this));
  }

  async getEventsList() {
    this.localMin = 0;
    // Don't load more if already loading or reached max
    if (this.eventList != undefined && this.eventList.length >= this.totalEvents) {
      return;
    }
    this.localMin = this.min;
    this.categoryId = localStorage.getItem("category");
    of(
      (await this.eventService.getAllEventsByCategory(this.categoryId, 20, this.min)).subscribe({
        next: (res) => {
          // console.log({ res }); //__CONSOLE_LOG__
          if (res) {
            let data: any;
            data = res;
            // // // console.log(data);
            // this.eventList = data[0];
            this.categoryName = data[1].category_name;
            this.totalEvents = data[2].total_events;
            // this.eventService.eventData.next(this.eventList);
            this.isLoading = false;
            if (!this.eventList) {
              this.eventList = data[0];
            } else {
              this.eventList = this.eventList.concat(data[0]); // Concatenate new events
            }
            this.min += 20; // Increment min for the next API call
            if (this.localMin != this.min) {
              this.eventService.eventData.next(this.eventList);
              this.isLoading = false;
              this.moreEvents = false;
            }
          } else {
            this.moreEvents = false;
            this.isLoading = false;
            this.eventList = {};
          }
        },
        error: (err) => {
          // // // console.log(err);
          this.moreEvents = false;
          this.isLoading = false;
          // console.error(err); //__CONSOLE_LOG__
        },
      })
    );
  }

  cardDetail(eventId: string, isPast: boolean, restricted: boolean, start_time: any, categoryName: any, default_uplaod: any, isHost: any, event: any) {
    if (event?.locked == 1 || event?.locked === true) {
      this.lockedPopupIsHost = !!isHost;
      this.showLockedPopup = true;
      return;
    }
    // // // console.log("isHost:", isHost);
    // this.loggingService.log("isHost:" + isHost);
    // this.loggingService.log("event clicked: " + eventId);
    // // // console.log(start_time, Date.now());


    // Clear service worker cache
    // this.clearServiceWorkerCache();
    event.startTime = event.start_time

    // Reset event-related data
    // this._eventDetail = null;
    //  this.allEvents = null;
    this.enc_eventData = this.encryptionService.encryptData(JSON.stringify(event));
    localStorage.setItem('eventData', this.enc_eventData);
    //  this.loggingService.log("eventData set: " + JSON.stringify(event));
    localStorage.setItem("eventId", eventId);
    localStorage.setItem("isHost", isHost);
    //  this.loggingService.log("is event restricted?: " + restricted);

    if (categoryName == "upcoming events" && Date.parse(start_time) > Date.now()) {
      localStorage.setItem('isScheduled', 'true');
      localStorage.setItem('isHost', isHost);
      //   this.loggingService.log("navigate to: /upcoming-event");
      //  this.router.navigateByUrl("/upcoming-event");
      this.router.navigateByUrl("/event-detail/" + isPast);
    } else {
      localStorage.setItem('isScheduled', 'false');
      if (restricted == true) {
        localStorage.setItem("access", 'restricted');
        //  this.loggingService.log("navigate to: /upload-selfie");
        this.router.navigateByUrl("/upload-selfie");
      } else {
        //  this.loggingService.log("navigate to: /event-detail");
        this.router.navigateByUrl("/event-detail/" + isPast);
      }
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // This function will be called when a scroll event occurs
  @HostListener('scroll', ['$event'])
  onCategoryScroll(event: Event) {
    event.stopPropagation();
    //  // // // console.log(event);

    if (this.eventList) {
      if (this.eventList.length < this.totalEvents && this.localMin != this.min) {
        this.moreEvents = true;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollPosition = window.scrollY;
        // // // // console.log(windowHeight, documentHeight, scrollPosition);

        if (windowHeight + scrollPosition >= (documentHeight - 100)) {
          // // // console.log('paging called');

          this.getEventsList();
          // // // console.log(this.showScrollButton);

          this.showScrollButton = window.scrollY > (windowHeight);
          // // // console.log(this.showScrollButton);
        }
      }
    }

  }


  onSearch(searchTerm: any) {
    if (searchTerm) {
      const filteredItems = this.eventList.filter((item: any) => {
        return item.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
      this.filteredData = filteredItems;
    }
  }

  cardDetail1(eventId: string, isPast: boolean) {
    // localStorage.setItem("eventId", eventId);
    localStorage.setItem("eventId", eventId);
    this.router.navigateByUrl("/event-detail/" + isPast);
  }

  navigateToRenew(): void {
    this.showLockedPopup = false;
    this.router.navigate(['/choose-subscription-v2']);
  }

  goBack() {
    localStorage.removeItem('eventId');
    localStorage.removeItem('isHost');
    localStorage.removeItem('isScheduled');
    localStorage.removeItem('access');
    localStorage.removeItem('eventData');
    this.location.back();
  }
}
